import * as Accordion from "@radix-ui/react-accordion"
import { useTranslation } from "react-i18next"
import { MdChevronLeft } from "react-icons/md"

export default function SeempActionGroup({
	modeLabel,
	nWarnings,
	totalDeviation,
	children,
	showDeviation,
}: {
	modeLabel: string
	nWarnings?: number
	totalDeviation?: number
	children: React.ReactNode[]
	showDeviation: boolean
}) {
	const { t } = useTranslation()

	return (
		<Accordion.Item
			value={modeLabel}
			className={`shadow-card overflow-hidden rounded-sm bg-white`}
			data-default-open={"true"}
		>
			<Accordion.Header className="flex min-h-12">
				<Accordion.Trigger
					className={
						"group hover:bg-dipai-secondary-800/5 data-[state=open]:bg-dipai-secondary-800/5 grid w-full grid-cols-[1fr_1.5rem] gap-3 px-3 outline-none"
					}
				>
					<div className={`flex h-full flex-col py-3 text-left`}>
						<p className={`text-dipai-secondary-901 text-menu h-6 font-semibold`}>
							{`${modeLabel} `}
							{nWarnings !== undefined && nWarnings > 0 ? (
								<span className={`text-amber-600`}>
									{`(${nWarnings} ${nWarnings === 1 ? t("INPUT REQUIRED").toLowerCase() : t("INPUTS REQUIRED").toLowerCase()})`}
								</span>
							) : null}
							{/* {totalDeviation !== undefined && totalDeviation !== 0 ? (
								<span
									className={
										showDeviation
											? totalDeviation > 0
												? "text-green-600"
												: totalDeviation < -5
													? "text-red-600"
													: "text-amber-600"
											: "text-black"
									}
								>
									{`(${t("TOTAL DEVIATION")}: ${showDeviation ? totalDeviation.toFixed(2) : "--"}%)`}
								</span>
							) : null} */}
						</p>
					</div>
					<div className={`flex items-center justify-center`}>
						<MdChevronLeft
							className="text-dipai-secondary-901 group-hover:text-dipai-secondary-600 size-7 rotate-180 transition-transform duration-300 ease-[cubic-bezier(0.87,_0,_0.13,_1)] group-hover:scale-110 group-hover:cursor-pointer group-data-[state=open]:rotate-270"
							aria-hidden
						/>
					</div>
				</Accordion.Trigger>
			</Accordion.Header>
			<Accordion.Content
				forceMount
				className={
					"data-[state=closed]:animate-slide-accordion-up data-[state=open]:animate-slide-accordion-down w-full overflow-hidden data-[state=closed]:h-0"
				}
			>
				<div className={`p-3`}>
					<Accordion.Root
						className="flex w-full flex-col gap-3"
						type="multiple"
					>
						{children}
					</Accordion.Root>
				</div>
			</Accordion.Content>
		</Accordion.Item>
	)
}
